import { useLocation, Navigate } from "react-router-dom";
import React from "react";
import { isExpired, decodeToken } from "react-jwt";
import { CHANGEPASSWORD, PROFILE } from "constants";

const ProtectedRoute = ({ children, check }) => {

  let token = localStorage.getItem('JWTToken');
  let userID = localStorage.getItem('userID');
  let profileCompleteStatus = localStorage.getItem('profileCompleteStatus');
  let location = useLocation();
  let resetPassword = localStorage.getItem('resetPassword');


  let isMyTokenExpired = true;
  let myDecodedToken = {};

  if (token) {
    myDecodedToken = decodeToken(token);

    isMyTokenExpired = isExpired(token);

    if ((userID != myDecodedToken.userId) || (isExpired(token) == true)) {
      localStorage.clear();
      userID = '';
      token = '';
    }

  }


  let childName = null;

  if (Array.isArray(children)) {
    const validChild = children.find(child => React.isValidElement(child) && child.props && child.props.name);
    if (validChild) {
      childName = validChild.props.name;
    }
  } else if (React.isValidElement(children) && children.props && children.props.name) {
    childName = children.props.name;
  }


  return (
    <>
      {((token != null && token != '') && (userID != null && userID != '') && check == 'login') ?

        (resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET) ?
          (childName && (childName == 'changePassword' || childName == 'logout')) ?
            children
            :
            <Navigate to="/vendor/changePassword" state={{ from: location }} replace />
          :
          (profileCompleteStatus == PROFILE.IS_COMPLETE) ?
            <Navigate to="/dashboard" state={{ from: location }} replace />
            :
            (childName && childName == 'logout') ?
              children
              :
            <Navigate to="/vendor/profile" state={{ from: location }} replace />


        :
        (check == 'logout') ?
          (token == null || token == '' || userID == null || userID == '') ?
            <Navigate to="/vendor/login" state={{ from: location }} replace />
            :

            (resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET) ?
              (childName && (childName == 'changePassword' || childName == 'logout')) ?
                children
                :
                <Navigate to="/vendor/changePassword" state={{ from: location }} replace />
              :

              (profileCompleteStatus == PROFILE.IS_COMPLETE) ?
                children
                :
                (childName && (childName == 'profile'||childName=='logout')) ?
                  children
                  :
                  <Navigate to="/vendor/profile" state={{ from: location }} replace />

          :
          children}
    </>
  )
};

export default ProtectedRoute;
